import { Outlet, Navigate } from 'react-router-dom';
import { useAuthStore } from '@/modules/auth/stores/authStore';

export default function AuthLayout() {
  const { isAuthenticated } = useAuthStore();

  // 이미 로그인된 경우 로비로 이동
  if (isAuthenticated) {
    return <Navigate to="/lobby" replace />;
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 safe-area-inset">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-primary-400">🎙️ Debate Battle</h1>
          <p className="text-slate-400 mt-2">실시간 음성 토론 배틀</p>
        </div>

        {/* Auth Forms */}
        <div className="card">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
